'use client'

import { useState, useCallback, useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { ConversationLinkActions } from '@marketplace-web/messaging/conversation-messaging-data'
import { clickEvent } from '@marketplace-web/escrow-pricing/escrow-pricing-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import ItemVerificationBuyerModal from '../ItemVerificationBuyerModal'

const ItemVerificationInfoLink = () => {
  const { track } = useTracking()

  const { conversation } = useConversationContext()

  const transactionId = conversation?.transaction?.id
  const transactionStatus = conversation?.transaction?.status
  const shipmentId = conversation?.transaction?.shipment?.id
  const shipmentStatus = conversation?.transaction?.shipment?.status

  const [isModalOpen, setIsModalOpen] = useState(false)

  const trackLinkClick = useCallback(() => {
    if (!transactionId) return

    const targetDetails = {
      transaction_id: transactionId,
      transaction_status: transactionStatus,
      shipment_id: shipmentId,
      shipment_status: shipmentStatus,
    }

    track(
      clickEvent({
        target: 'physical_auth_buyer',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }, [track, transactionId, transactionStatus, shipmentId, shipmentStatus])

  const handleModalOpen = useCallback(() => {
    trackLinkClick()
    setIsModalOpen(true)
  }, [trackLinkClick, setIsModalOpen])

  const handleClose = () => setIsModalOpen(false)

  useEffect(() => {
    const handleShipmentLinkClick = event => {
      const element = event.target as HTMLElement

      if (!element.classList.contains(ConversationLinkActions.OfflineVerificationInfoLink)) return

      event.preventDefault()
      handleModalOpen()
    }

    document.body.addEventListener('click', handleShipmentLinkClick)

    return () => {
      document.body.removeEventListener('click', handleShipmentLinkClick)
    }
  }, [handleModalOpen])

  return <ItemVerificationBuyerModal show={isModalOpen} onClose={handleClose} />
}

export default ItemVerificationInfoLink
